import { onMount } from 'svelte';
import pb from './pocketbase';

let user;

// Validate token and fetch user data
export async function validateTokenAndFetchUserData() {
    const token = localStorage.getItem("pb_token");
    const user = localStorage.getItem("pb_user");

    if (token && user) {
        try {
            // Check if token is valid
            if (pb.authStore.isValid) {
                const userData = JSON.parse(user);
                
                // Fetch and store role information (non-blocking)
                if (userData.role) {
                    pb.collection('role').getOne(userData.role).then(role => {
                        localStorage.setItem("pb_user_role", JSON.stringify(role));
                    }).catch(error => {
                        // Don't remove existing role data if fetch fails
                    });
                }
                
                return user;
            } else {
                // Token is invalid or expired
                localStorage.removeItem("pb_user_role");
                return null;
            }
        } catch (error) {
            localStorage.removeItem("pb_user_role");
            return null;
        }
    } else {
        localStorage.removeItem("pb_user_role");
        return null;
    }
}
